import { Matches } from '@react-hook/media-query';
import { SORT_BREAKPOINTS } from '@src/consts/common';
import { TQueries } from '@src/models/common';

export const getBreakpoint = (matches: Matches<TQueries<string>>) => {
  return SORT_BREAKPOINTS.find(([key]) => matches[key])?.[0] as keyof TQueries;
};
